/**
 * Width the generated PDF actually prints on. An A4 page is 794 CSS px wide at
 * 96 dpi, and the generator applies 30 px margins on both sides (see the
 * `page.pdf` margins in anisenior-api, routes/template-documents). Tables and
 * images wider than this used to shrink the whole document to fit.
 */
export const PRINTABLE_WIDTH_PX = 734;

/**
 * Outer width of the editor frame so that its editable area matches the
 * printable width exactly: Jodit pads `.jodit-wysiwyg` by 8 px and draws a
 * 1 px border on each side of the container.
 */
export const EDITOR_FRAME_WIDTH_PX = PRINTABLE_WIDTH_PX + 2 * 8 + 2 * 1;
